<template>
  <section class="invite">
    <div class="container">
      <h4 class="cs-textstyle-page-title">
        CTO Circle is intended for <strong>CTOs</strong> and
        <strong>senior technology leaders</strong> from companies with
        <strong class="one-million">at least US$1 million</strong> in annual
        revenue.
      </h4>
      <p>
        Membership is free, by invitation only.<br />If you think you’re a good
        fit, request an invite.
      </p>
      <cs-button
        href="https://csuitecircle.typeform.com/to/fEytYh02"
        variant="primary"
        fill="solid"
        size="medium"
        target="_blank"
        :style="{
          '--cs-button-color': '#ffffff',
          '--cs-button-text-color': '#007ea3'
        }"
        >Request an Invite</cs-button
      >
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.invite {
  background: var(--cs-primary-dark);
  padding: 80px 0;
  text-align: center;
  h4 {
    color: #fff;
    max-width: 800px;
    margin: 0 auto 40px;
    font-weight: 400;
  }

  p {
    color: #f5f7f6;
    margin-bottom: 30px;
  }
  .one-million {
    color: var(--cs-primary-light);
  }
}
</style>
